export default "__VITE_ASSET__BmzgSTYW__"